'use client';

import { c as _c } from "react/compiler-runtime";
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
function WorldTitle() {
  const $ = _c(2);
  const {
    roomData
  } = useCheckEnterRoomContext();
  if (!roomData.title) {
    return null;
  }
  let t0;
  if ($[0] !== roomData.title) {
    t0 = <h1 data-component="world-title" className="text-lg leading-6.5 font-extrabold tracking-[0.1px] wrap-break-word lg:hidden lg:text-2xl lg:leading-8 landscape:text-lg landscape:leading-6.5">{roomData.title}</h1>;
    $[0] = roomData.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default WorldTitle;